import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { Entry } from 'contentful';
import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import RichTextComponentModel from './rich-text-component-model';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';

export default class AccordionSetComponentModel extends BaseComponentModel {
  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'AccordionSet';

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = ['accordionSet'];
    const notEmptyFields = ['accordionSet'];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  protected shouldReturnChildEntities(entry: Entry<any>): IShouldReturnEntity {
    const dataRequiredFields = [
      'fields',
      'fields.description',
      'fields.title',
      'fields.description.fields',
    ];
    const dataNotEmptyFields = ['fields'];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      dataRequiredFields,
      dataNotEmptyFields,
    );
  }

  accordionSet: any[];

  constructor(data: any, appSettings: ApplicationSettings) {
    super('accordionSet', appSettings);

    const accordionSetShouldReturn = this.shouldReturnEntity(data);

    if (!accordionSetShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...accordionSetShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    const fullAccordionSet = data.accordionSet;

    const includedAccordionSet = fullAccordionSet.filter(
      (a) => this.shouldReturnChildEntities(a).shouldReturn,
    );
    const excludedSets = fullAccordionSet.filter(
      (a) => !this.shouldReturnChildEntities(a).shouldReturn,
    );
    excludedSets.forEach((a) => {
      this.exclusionReasons.push(...this.shouldReturnChildEntities(a).shouldNotReturnReasons);
    });

    this.accordionSet = includedAccordionSet?.map((x, index) => {
      return {
        id: x?.fields?.id ? x?.fields?.id : 'accord' + index,
        heading: x?.fields?.title,
        heapIdentifier: 'tab-accordian' + index,
        content: new RichTextComponentModel(x?.fields?.description?.fields, appSettings),
      };
    });
  }
}
